<template>
    <div class="company-contain">
        <div class="tab_box">
            <el-tabs v-model="ShortTab" type="card" @tab-click="handleClick">
                <el-tab-pane label="百家号" name="first">
                    <Baidu :activeName="activeName" :stuId="stuId" @stuList="handleList" @saveForm="saveForm"
                           v-if="this.ShortTab == 'first'">
                    </Baidu>
                </el-tab-pane>
                <el-tab-pane label="大鱼号" name="second">
                    <Dayu v-if="this.ShortTab == 'second'">
                    </Dayu>
                </el-tab-pane>
                <el-tab-pane label="简书" name="third">
                    <JianShu v-if="this.ShortTab == 'third'">
                    </JianShu>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Baidu from "./StuExpert/Baidu";
    import Dayu from "./StuExpert/Dayu";
    import JianShu from "./StuExpert/JianShu";

    export default {
        name: 'PicExpert',
        props: ['activeName', 'stuId'],
        components: {
            Baidu,
            Dayu,
            JianShu
        },
        data() {
            return {
                ShortTab: this.$route.query.ShortTab || 'first',
            }
        },
        mounted() {
        },
        methods: {
            handleList(val) {
                this.$emit('picList', val)
            },
            saveForm(val){
                this.$emit('saveForm', true)
            },
            handleClick(tab, event) {
            },
        },
    }
</script>

<style scoped lang="scss">
    .activeClass {
        background: #2338E6;
        color: #ffffff;
    }

    .company-contain {
        margin-bottom: 20px;
        background-color: #ffffff;

        .tab_box {
            ::v-deep .el-tabs__header {
                display: flex;
                justify-content: center;
                border-bottom: 1px solid #EEEEEE !important;
                background: #ffffff !important;
            }

            ::v-deep .el-tabs__header .is-active {
                border-bottom: 2px solid #4D5AFF !important;
            }

            ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
                display: flex !important;
                justify-content: space-around !important;
                width: 300px !important;
            }
        }
    }
</style>
